import {
   HttpEvent,
   HttpHandler,
   HttpInterceptor,
   HttpParams,
   HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TrimInputsInterceptor implements HttpInterceptor {
   // Exclude fields from trimming by name (if spaces are needed in the input)
   private excludedFields = [];

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let modifiedRequest = req;

      // Handle query parameters for GET requests
      if (req.method === 'GET' && req.params) {
         const trimmedParams = this.trimQueryParams(req.params);
         modifiedRequest = req.clone({ params: trimmedParams });
      } else if (
         // Handle request body for other HTTP methods
         typeof req.body === 'object' &&
         !Array.isArray(req.body) &&
         !(req.body instanceof FormData)
      ) {
         const trimmedBody = this.trimFields(req.body);
         modifiedRequest = modifiedRequest.clone({ body: trimmedBody });
      }

      return next.handle(modifiedRequest);
   }

   private trimQueryParams(params: HttpParams): HttpParams {
      let trimmedParams = new HttpParams();

      params.keys().forEach((key) => {
         const value = params.get(key);
         if (value !== null) {
            trimmedParams = trimmedParams.append(
               key,
               this.excludedFields.includes(key) ? value : value.trim(),
            );
         }
      });

      return trimmedParams;
   }

   private trimFields(obj: any): any {
      return Object.entries(obj).reduce((acc, [key, value]) => {
         if (this.excludedFields.includes(key)) {
            acc[key] = value;
         } else if (typeof value === 'string') {
            acc[key] = value.trim();
         } else if (value && typeof value === 'object' && !Array.isArray(value)) {
            acc[key] = this.trimFields(value);
         } else {
            acc[key] = value;
         }
         return acc;
      }, {});
   }
}
